import { Link } from "react-router-dom";
import type { GossipEvent } from "@/types/content";
import StatusBadge from "@/components/base/StatusBadge";
import HeatMeter from "@/components/base/HeatMeter";

interface EventCardProps {
  event: GossipEvent;
  index?: number;
}

export default function EventCard({ event, index }: EventCardProps) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <Link to={`/event/${event.id}`} className="block cursor-pointer">
        <div className="relative w-full h-52 overflow-hidden bg-background-200">
          <img
            src={event.cover}
            alt={`${event.title} 事件封面`}
            title={`${event.title} - 热门吃瓜时间线`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-transparent" />
          <div className="absolute left-3 top-3 flex items-center gap-2">
            <span className="rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-medium text-foreground-800 whitespace-nowrap">
              {event.category}
            </span>
          </div>
          {typeof index === "number" && index < 3 && (
            <span className="absolute right-3 top-3 inline-flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold w-7 h-7">
              {index + 1}
            </span>
          )}
          <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
            <StatusBadge status={event.status} className="bg-background-50/95 backdrop-blur" />
            <span className="text-xs text-background-50/90 whitespace-nowrap">
              更新 {event.updatedAt}
            </span>
          </div>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <Link to={`/event/${event.id}`} className="cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-600">
            {event.title}
          </h3>
        </Link>
        <p className="mt-2 line-clamp-2 text-xs md:text-sm leading-relaxed text-foreground-600">
          {event.summary}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {event.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-50 px-2 py-0.5 text-xs text-secondary-800 whitespace-nowrap"
            >
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-auto flex items-center justify-between gap-2 pt-4">
          <HeatMeter heat={event.heat} />
          <span className="inline-flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-time-line" />
            </span>
            {event.readingTime}
          </span>
        </div>
      </div>
    </article>
  );
}